import { useMemo } from 'react';

import { OrderEntity, OrderStatusType } from 'api/types/entity';
import { isGlobalProject } from 'config';
import { lodash } from 'helpers';

import { ActionType } from '../types';

export const useOrderActions = (order: OrderEntity | null) => {
  const actions = useMemo(() => {
    const isOrderUnsigned = order?.status === OrderStatusType.AwaitingSigning;

    const canDownload = isGlobalProject() && !!order?.number;

    return lodash.compact([
      isOrderUnsigned ? ActionType.Sign : undefined,
      isOrderUnsigned ? ActionType.Edit : undefined,
      isOrderUnsigned ? ActionType.Delete : undefined,
      canDownload ? ActionType.Download : undefined,
    ]);
  }, [order?.status, order?.number]);

  return { actions };
};
